// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer__2j8xa","about":"about__ZGOih"};